import React from 'react';
import { motion } from 'framer-motion';
import { workspacePanels } from '../../data/noetivra';
import { fadeUp } from '../../utils/motion';
export function NoetivraWorkspaces() {
  return <section aria-labelledby="workspaces-title" className="bg-surface-bg border-b border-line py-20 lg:py-24" data-id="element-899" data-mp="1k0frzwvuhia1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-900" data-mp="1oyhdspknnvp7">
        <motion.h2 {...fadeUp} id="workspaces-title" className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight mb-12 max-w-2xl" data-id="element-901" data-mp="1owwg4r31nwn4">
          Two workspaces, one shared record
        </motion.h2>
        <motion.ul {...fadeUp} className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line rounded-lg overflow-hidden" data-id="element-902" data-mp="22q5ruyegsu8t">
          {workspacePanels.map((panel, index) => <li key={panel.title} className={`p-8 ${index === workspacePanels.length - 1 ? 'bg-navy-deep text-white' : 'bg-white'}`} data-id="element-903" data-mp="rdv4j7ihpqbr" data-mpi={index}>
              <h3 className={`font-heading font-bold text-xl mb-3 ${index === workspacePanels.length - 1 ? 'text-white' : 'text-ink-dark'}`} data-id="element-904" data-mp="23cqmuni6g8uw">
                {panel.title}
              </h3>
              <p className={`leading-relaxed ${index === workspacePanels.length - 1 ? 'text-white/80' : 'text-ink-muted'}`} data-id="element-905" data-mp="2d81teijfm9rk">
                {panel.body}
              </p>
            </li>)}
        </motion.ul>
      </div>
    </section>;
}